import { faCheck, faHourglass, faNotdef, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Component, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { MsisdnDto, ResultListDto, SearchResultMsisdnDto } from '../../service/dto';
import { Filter, OnTableChange, TableColumn } from '../../components/table/table.component';
import { Router } from '@angular/router';
import { HttpSubscriberService } from '../../service/http-subscriber.service';
import { finalize } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
	selector: 'app-subscriber-sim-search',
	templateUrl: './subscriber-sim-search.component.html',
	styleUrl: './subscriber-sim-search.component.scss',
	standalone: false
})
export class SubscriberSimSearchComponent implements OnInit, OnDestroy {
	results?: ResultListDto<SearchResultMsisdnDto>;
	loading = false;
	filters: Filter[] = [
		{ label: "Msisdn", name: "msisdn", type: "Text", format: '^\\d{7,15}$' }, // 7-15 digits
		{ label: "Iccid", name: "iccid", type: "Text", format: '^\\d{18,20}$' }, // 19-20 digits
		{ label: "Sim Serial", name: "simSerial", type: "Text", format: '^\\w{8,20}$' }, // 8-20 alphanumeric
	];
	filterForm!: FormGroup;

	columnRef: TableColumn[] = [
		{ "title": "ID Number", "property": "person.idNumber" },
		{ "title": "MSISDN", "property": "msisdn.internationalMsisdn" },
		{ "title": "ICCID", "property": "msisdn.iccid" },
		{ "title": "Network", "property": "msisdn.partner.name" },
		{ "title": "Doc Type", "property": "document.documentType" },
		{ "title": "Doc Number", "property": "document.documentNumber" },
		{ "title": "Given Names", "cellRef": "givenNames", exportValue: item => `${item.document.firstName??''} ${item.document.secondName??''} ${item.document.otherNames??''}` },
		{ "title": "Last Name", "property": "document.lastName" },
		{ "title": "Date of Birth", "property": "document.dateOfBirth" },
		{ "title": "From Date", "property": "msisdn.startDate" },
		{ "title": "To Date", "cellRef": "toDate", exportValue: item => `${item.msisdn.endDate}` },
		{ "title": "Status", "cellRef": "simStatus", exportValue: item => `${item.msisdn.simStatus}` },
		{ "title": "Validation", "cellRef": "documentStatus", exportValue: item => `${item.msisdn.documentStatus}` }
	];

	faCheck = faCheck;
	faXmark = faXmark;
	faNotdef = faNotdef;
	faHourglass = faHourglass;


	constructor(private service: HttpSubscriberService, private router: Router, private modelService: NgbModal, private formBuilder: FormBuilder) {
	}

	ngOnInit(): void {
		this.filterForm = this.formBuilder.group({
			msisdn: ['', [Validators.pattern('^\\d{7,15}$')]],
			iccid: ['', [Validators.pattern('^\\d{18,20}$')]],
			simSerial: ['', [Validators.pattern('^\\w{8,20}$')]]
		});
	}

	ngOnDestroy(): void {
	}

	trackByHashCode(index: number, item: SearchResultMsisdnDto): any {
		return item.hashCode;
	}

	open(input: SearchResultMsisdnDto) {
		this.router.navigate(['/subscriber', 'sim-view', input.person.id, input.msisdn.id]);
	}
	doFetchResults(input: OnTableChange) {
		const filter: any = {
			msisdn: input.filters.filter(i => i.name == 'msisdn')[0]?.value,
			iccid: input.filters.filter(i => i.name == 'iccid')[0]?.value,
			simSerial: input.filters.filter(i => i.name == 'simSerial')[0]?.value,
			startDate: input.filters.filter(i => i.name == 'startDate')[0]?.value,
			endDate: input.filters.filter(i => i.name == 'endDate')[0]?.value
		};
		this.loading = true;
		this.service.searchByMsisdn(filter as MsisdnDto, input.pageIndex, input.pageSize)
			.pipe(finalize(() => {
				this.loading = false;
			}))
			.subscribe(result => {
				this.results = result;
			});
	}
	showSearchHelp(input: TemplateRef<any>) {
		this.modelService.open(input);
	}
	getFilter(name: string): Filter {
		return this.filters.filter(item => item.name == name)[0];
	}
}
